import Vue from 'vue'
import VueRouter from 'vue-router'
import {userGuard} from "./middleware/guards"
import Forbidden from "~/components/pages/Forbidden"
import auth from './auth'
import speechAnalysis from './stat/speechAnalysis'
import tariffication from './stat/tariffication'
import operators from './stat/operators'
import byDays from "~/components/pages/stat/ByDays"
import AiAnalysis from "~/components/pages/stat/AiAnalysis"
import ComplaintsReport from "~/components/pages/stat/ComplaintsReport"
import AiCardAnalyses from "~/components/pages/stat/AiCardAnalyses"
import MonthlyReport from "~/components/pages/stat/MonthlyReport"
import PredictionReport from "~/components/pages/stat/PredictionReport"
import ContractReport from "~/components/pages/stat/contracts/Default"
import defaultFormView from "~/components/pages/stat/forms/Default.vue"
import dashboard from "~/components/pages/dashboards/DashboardPage"
import KlnByOperators from "~/components/pages/stat/KlnByOperators"
import TargetAi from "~/components/pages/stat/TargetAi"
import CallTasksList from "../components/pages/stat/call-tasks/List.vue"
import CallTasksCreate from "../components/pages/stat/call-tasks/Create.vue"
import CallTasksEdit from "../components/pages/stat/call-tasks/Edit.vue"
import PrompterControl from "~/components/pages/stat/PrompterControl.vue"
import KpiRg from "~/components/pages/stat/KpiRg.vue"
import WfmReport from "~/components/pages/stat/WfmReport.vue"
import PortalAnalytics from "~/components/pages/stat/PortalAnalytics.vue"

// eslint-disable-next-line
import OnDevelopment from "~/components/pages/OnDevelopment.vue"

import hommyTest from "~/components/pages/HommyTest"
import otm from './otm'
import reports from './reports'
import documentFlow from './document-flow'

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        ...auth,
        ...speechAnalysis,
        ...tariffication,
        ...operators,
        ...otm,
        ...reports,
        ...documentFlow,
        {
            path: '/stat/forms',
            name: 'forms.report',
            component: defaultFormView,
            beforeEnter: userGuard
        },
        {
            path: '/stat/by-days',
            name: 'by-days',
            component: byDays,
            beforeEnter: userGuard
        },
        {
            path: '/stat/ai-analysis-statistic',
            name: 'ai-analysis-statistic',
            component: AiAnalysis,
            beforeEnter: userGuard
        },
        {
            path: '/stat/complaints-report',
            name: 'complaints-report',
            component: ComplaintsReport,
            beforeEnter: userGuard
        },
        {
            path: '/stat/ai-card-analyses',
            name: 'ai-card-analyses',
            component: AiCardAnalyses,
            beforeEnter: userGuard
        },
        {
            path: '/stat/monthly-report',
            name: 'monthly-report',
            component: MonthlyReport,
            beforeEnter: userGuard
        },
        {
            path: '/stat/prediction-report',
            name: 'prediction-report',
            component: PredictionReport,
            beforeEnter: userGuard
        },
        {
            path: '/stat/contract-report',
            name: 'contract-report',
            component: ContractReport,
            beforeEnter: userGuard
        },
        {
            path: '/stat/kln-by-operators',
            name: 'kln-by-operators',
            component: KlnByOperators,
            beforeEnter: userGuard
        },
        {
            path: '/stat/voice-assistants',
            name: 'voice-assistants',
            component: TargetAi,
            beforeEnter: userGuard
        },
        {
            path: '/stat/call-tasks',
            name: 'call-tasks.list',
            component: CallTasksList,
            beforeEnter: userGuard
        },
        {
            path: '/stat/call-tasks/create',
            name: 'call-tasks.create',
            component: CallTasksCreate,
            beforeEnter: userGuard
        },
        {
            path: '/stat/call-tasks/:id/edit',
            name: 'call-tasks.edit',
            component: CallTasksEdit,
            beforeEnter: userGuard
        },
        {
            path: '/stat/prompter-control',
            name: 'prompter-control',
            component: PrompterControl,
            beforeEnter: userGuard
        },
        {
            path: '/stat/kpi/rg',
            name: 'kpi.rg',
            component: KpiRg,
            beforeEnter: userGuard
        },
        {
            path: '/stat/wfm',
            name: 'wfm.run',
            component: WfmReport,
            beforeEnter: userGuard
        },
        {
            path: '/stat/portal-analytics',
            name: 'portal-analytics',
            component: PortalAnalytics,
            beforeEnter: userGuard
        },

        {
            path: '/',
            name: 'dashboard',
            component: dashboard,
            beforeEnter: userGuard
        },
        {
            path: '/403',
            name: 'Forbidden',
            component: Forbidden,
        },
        {
            path: '/hommyTest',
            name: 'hommyTest',
            component: hommyTest,
            beforeEnter: userGuard
        },
        {
            path: '*',
            redirect: '/'
        }

    ],
    mode: 'history',
})

export default router
